import React from 'react';
import UPopup from "ubs-framework/v2/UPopup";

const UNameJobInfo = React.memo((props) => {
    return (
        <React.Fragment>
            <div className={`u_nameJobInfo ${props.className}`}>
                {props.avatar && <div className="u_mr-10">{props.avatar}</div>}
                <div className="u_nameJobInfo-inner">
                    {props.name && <p>{props.name}</p>}
                    {props.job && <span>{props.job}</span>}
                    {props.jobWithTooltip && <UPopup
                        params={{className: "u_tooltip"}}
                        desc={<span>{props.jobWithTooltip}</span>}
                    >
                        <span className="u_one-line">{props.jobWithTooltip}</span>
                    </UPopup>}
                </div>
            </div>
        </React.Fragment>
    );
});

export default UNameJobInfo;
